/**
 * Router JS
 *
 * Mixin 형태로 제공되는 네비게이션 가드입니다.
 * 공통 스토어의 isChanged 상태 값이 True라면 경고 Toast 메세지를 출력하고 네비게이션 진행을 차단합니다.
 *
 * @since 2018-07-23
 * @author ms1124.kim
 *
 * - 2019-04-04 devp014 (Nanhyoung.ro) : isDownload 상태 값이 true 일 경우 화면 이동 불가능 하도록 수정
 */

import {
  bus,
  menuPathToCode,
  menuPathToInfo
} from '~/utils/multirw'

// Mixin export 모듈
export default {
  // 인-컴포넌트 네비게이션 가드
  beforeRouteLeave (to, from, next) {
    try {
      // 0. Page 컴포넌트에 isPrevented 메서드가 있다면 호출
      if (typeof this.isPrevented === 'function' && this.isPrevented()) {
        let message = this.$t('msg.isChangeData')
        if (!_.isUndefined(this.isPreventMessage) && this.isPreventMessage !== '') {
          message = this.isPreventMessage
        }
        this.$q.notify({
          icon: 'warning',
          color: 'red-15',
          message: message,
          position: 'top'
        })
        return
      }

      // TAMS - 메뉴 권한 검증
      const menu = this.$store.state.common.navigation.menu
      if (!menuPathToCode(to.path, menu)) {
        this.$alertPopUp.show(this.$t('msg.noPermissionThisMenu'), 'error')
        return
      }

      // TAMS - 화면 체크인 중 이동 방지 (Write 메뉴 권한)
      const menuInfo = menuPathToInfo(from.path, menu)
      const menuPermission = Boolean(_.get(menuInfo, ['admin_menu_role_type'], 0))
      if (this.$store.getters['common/multirw/isMultiRWGuard'] && menuPermission) {
        bus.$emit('guard-show', {
          path: to.path,
          name: to.name,
          params: to.params
        })
        return
      }

      // 스토어의 공통 Getters - download 진행 중일 경우 체크 (true: 다운로드 진행 중)
      if (this.$store.getters['common/common/isDownloaded']) {
        const message = this.$t('msg.fileDownloadInProgress')
        this.$q.notify({
          icon: 'warning',
          color: 'red-15',
          message: message,
          position: 'top'
        })
        return
      }

      // 2. 잠금상태에서 네비게이션 가드 (TAMS)
      if (this.$store.getters['common/lockmode/isLock']) {
        // 비정상적인 행위 감지
        this.$q.notify({
          icon: 'warning',
          color: 'red-15',
          message: this.$t('cmn.msg_detectAbnormalAction'),
          position: 'top'
        })
        // this.$store.dispatch('common/authenticate/logout')
        window.location.replace('/')
        return
      }
      // 3. 모두 통과하면 네비게이션 이동
      // this.$store.commit('common/navigation/setCurrentMenu', void 0) // TAMS 제외
      // 4. 네비게이션 이동 시 HA prefix 원복
      // geWindow 일 경우 원복하지 않음.
      // if (!this.$route.query.geWindow) {
      //   if (_.get(this, ['$store', 'state', 'common', 'common', 'apiPrefix']) !== '/') {
      //     this.$store.commit('common/common/setApiPrefix', '/')
      //   }
      // } else if (_.get(this, ['$store', 'state', 'common', 'common', 'apiPrefix', 'length'], 0) === 0) {
      //   this.$store.commit('common/common/setApiPrefix', `/GE:${this.$route.query.geWindow}/`)
      // }

      // TAMS, GE/HA Prefix
      const prefix = _.get(this, ['$store', 'state', 'common', 'common', 'apiPrefix'])
      if (_.get(prefix, ['length'], 0) > 1) { // '', '/'
        if (!prefix.startsWith('/GE:')) { // HA prefix(Slave) 설정된 경우. ex) /ha:34/~~~
          this.$store.commit('common/common/setApiPrefix', '/')
        } else if (prefix.indexOf('/ha:') !== -1) { // GE window면서 HA prefix(Slave) 설정되어 있을 경우. ex /GE:TAMS-1a2b3c4/ha:34/~~~
          const
            splitPrefix = prefix.split('/'),
            filterPrefix = splitPrefix.filter(chunk => !chunk.startsWith('ha:')), // ha prefix 만 제거
            resultPrefix = filterPrefix.join('/')
          this.$store.commit('common/common/setApiPrefix', resultPrefix)
        }
      }
      // 5. 모니터링 / 배치 작업 시 잠금화면 방지 원복 (TAMS)
      this.$store.commit('common/common/setPreventLock', false)

      // 6. Init savepoint-rollback counting (TAMS)
      this.$store.commit('common/saveRollback/initStore')

      next()
    } catch (e) {
      this.$log('[Global Navagation Guard GUI Error (beforeRouteLeave)]', e)
      next()
    }
  }
}
